import React from "react";

type ErrorMessageProps = {
  msg?: string;
};

const ErrorMessage = ({msg}: ErrorMessageProps) => {
  if (!msg) return null;

  return <p className="text-xs mt-1 text-error-700 md:max-w-[12.5rem]">{msg}</p>;
};

export default React.memo(ErrorMessage);
